import { getCurrentInstance } from '@vue/composition-api';

const useCommonModal = () => {
  const vm = getCurrentInstance();
  const modal = vm.root.proxy.$vfm;

  const showModal = (modalComponent, targetComponent) => {
    modal.show({
      component: modalComponent,
      bind: {
        name: 'AppModal'
      },
      slots: {
        default: {
          component: () => targetComponent
        }
      }
    });
  };

  return {
    showModal,
    modal
  };
};

export default useCommonModal;
